/**
 * User: nir
 * Date: 16/10/2016
 * Time: 0:01
 */

if (window['jQuery']) {
    window.jQuery(function ($) {
        var elem = $('#end-of-content');
        if (!elem || !elem.length) return;

        elem.one('inview', function reached() {
            trackCTA('completed_reading');
        });
    });
}